import React from "react";
import classNames from "../classNames";
import { formatTinNo } from "../InputFactory/utils";

const noop = () => {};

const defaultProps = {
  type: "text",
  strict: false,
  noLetters: false,
  onChange: noop,
};

function InputString({
  className = "bg-white border border-1 border-dark-subtle",
  strict,
  noLetters,
  onChange,
  uppercase,
  lowercase,
  formatTin,
  minLength,
  field,
  ...props
}) {
  function onInput(e) {
    let value = e.target.value.normalize("NFC");
    const character = value.charAt(value.length - 1);

    // strict: only letter
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }

    // noLetters: block letters
    if (noLetters && /[a-zA-Z]/.test(character)) {
      return;
    }

    if (uppercase) {
      value = value.toUpperCase();
      e.target.value = value;
    }

    if (lowercase) {
      value = value.toLowerCase();
      e.target.value = value;
    }

    // Special handling for TIN fields
    if (field === "tinNo" || typeof formatTin === "function") {
      const formatter = typeof formatTin === "function" ? formatTin : formatTinNo;
      const formatted = formatter(value);
      value = formatted;
      e.target.value = formatted;
    }

    onChange(value);
  }

  return (
    <input
      className={classNames("form-control", className)}
      onInput={onInput}
      minLength={minLength}
      {...props}
    />
  );
}

InputString.defaultProps = defaultProps;
export default InputString;
